module.exports = __webpack_public_path__ + "media/img/corporate/mask-mobile-bd801b9f84b8c191d2ef602976c58263.svg";